import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "breakout-room-item__wrapper" }
const _hoisted_2 = { class: "breakout-room-item__room-name" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconDotsCircle = _resolveComponent("IconDotsCircle")
  const _component_IconMenuRightOutline = _resolveComponent("IconMenuRightOutline")
  const _component_IconMenuDownOutline = _resolveComponent("IconMenuDownOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconHandBackLeftOutline = _resolveComponent("IconHandBackLeftOutline")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_IconSendOutline = _resolveComponent("IconSendOutline")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_SendMessageDialog = _resolveComponent("SendMessageDialog")

  return (_openBlock(), _createElementBlock("li", {
    key: $options.roomName,
    class: "breakout-room-item",
    onMouseenter: _cache[4] || (_cache[4] = $event => ($data.elementHoveredOrFocused = true)),
    onMouseleave: _cache[5] || (_cache[5] = $event => ($data.elementHoveredOrFocused = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_NcButton, {
        variant: "tertiary",
        "aria-label": $options.toggleParticipantsListLabel,
        onFocus: _cache[0] || (_cache[0] = $event => ($data.elementHoveredOrFocused = true)),
        onBlur: _cache[1] || (_cache[1] = $event => ($data.elementHoveredOrFocused = false)),
        onClick: $options.toggleParticipantsVisibility
      }, {
        icon: _withCtx(() => [
          (!$data.elementHoveredOrFocused)
            ? (_openBlock(), _createBlock(_component_IconDotsCircle, {
                key: 0,
                size: 20
              }))
            : (!$data.showParticipants)
              ? (_openBlock(), _createBlock(_component_IconMenuRightOutline, {
                  key: 1,
                  size: 20
                }))
              : (_openBlock(), _createBlock(_component_IconMenuDownOutline, {
                  key: 2,
                  size: 20
                }))
        ]),
        _: 1
      }, 8, ["aria-label", "onClick"]),
      _createElementVNode("span", _hoisted_2, _toDisplayString($options.roomName), 1),
      (!$options.isParticipantsEditor)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($options.showJoinButton)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 0,
                  onClick: $options.joinRoom
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Join')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($options.canModerate)
              ? (_openBlock(), _createBlock(_component_NcActions, {
                  key: 1,
                  inline: $options.showAssistanceButton ? 1 : 0,
                  "force-menu": !$options.showAssistanceButton
                }, {
                  default: _withCtx(() => [
                    ($options.showAssistanceButton)
                      ? (_openBlock(), _createBlock(_component_NcActionButton, {
                          key: 0,
                          onClick: $options.dismissRequestAssistance
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_IconHandBackLeftOutline, { size: 18 })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Dismiss request for assistance')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcActionButton, {
                      onClick: _cache[2] || (_cache[2] = $event => ($data.isDialogOpened = true))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconSendOutline, { size: 20 })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Send message to room')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["inline", "force-menu"]))
              : _createCommentVNode("", true),
            ($data.isDialogOpened)
              ? (_openBlock(), _createBlock(_component_SendMessageDialog, {
                  key: 2,
                  "dialog-title": $options.dialogTitle,
                  token: $options.roomToken,
                  onSubmit: $options.sentMessageToRoom,
                  onClose: _cache[3] || (_cache[3] = $event => ($data.isDialogOpened = false))
                }, null, 8, ["dialog-title", "token", "onSubmit"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("ul", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512), [
      [_vShow, $data.showParticipants]
    ])
  ], 32))
}